// userService.js
import { get, post, put, Delete, patch } from './common';


export const usersList = (filterData, headers) => {
  return get('user/list', filterData, headers);
};

export const singleUser = (id) => {
  return get('user/' + id);
};

export const deleteUser = (id) => {
  return Delete('user/' + id);
};

export const addUsers = (data) => {
  return post('user', data);
};

export const updateUser = (userId, data) => {
  return put('user/' + userId, data);
};

export const listExpertUsers = (params) => {
  return get('user/list-all', params);
};

export const usersList1 = (filterData, headers) => {
  return get('user/list', filterData, headers);
};

export const getExpertScheduleUsers = (filterData) => {
  return get('user/list-expert-schedule-users', filterData);
};

export const updateWorkingHours = (updatedData) => {
  return patch('user/update-working-hours', updatedData);
};

export const changePasswordService = (data) => {
  return patch('user/change-password', data);
};

export const updateCompanyDetails = (data) => {
  return patch('user/update-company-details/', data);
};

export const updateProfilePic = (userId, formData) => {
  console.log("formData@updateProfilePic >> ", formData);
  return patch(`user/${userId}/profile-pic/`, formData, {
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  });
};

export const updateUserstatus = (data) => {
  return patch(`user/update-user-status`, data);
};

